export default "__VITE_ASSET__BipZYFcC__"